import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
  import { useParams ,useHistory,} from "react-router-dom";

  import { useDispatch } from 'react-redux';
  import { useSelector } from "react-redux";
  
import Loading from "../../Loading/Loading"; 

import loadable from '@loadable/component';
import SettingsCoursePageFeatures from "./SettingsCoursePageFeatures";
import SettingsCourseCardFeatures from "./SettingsCourseCardFeatures";
import CourseMenuCardBlue from "./CourseMenuCardBlue";

// npm i @loadable/component 

let lazyLoad =   <Loading/>;
  
const CourseTitle = loadable(() => import("./CourseTitle"), {
  fallback: lazyLoad  });

  const WhatsIncluded = loadable(() => import("./WhatsIncluded"), {
    fallback: lazyLoad  });
  
 
    const AddThumbnail = loadable(() => import("./AddThumbnail"), {
      fallback: lazyLoad  });
  
      const AddDemoVideos = loadable(() => import("./AddDemoVideos"), {
        fallback: lazyLoad  });
        
        const SetCoursePriceType = loadable(() => import("./SetCoursePriceType"), {
          fallback: lazyLoad  });
       
        const WhatsNextAfterYTVideo = loadable(() => import("./WhatsNextAfterYTVideo"), {
          fallback: lazyLoad  });
          
          const WhatsNextAfterYTVideo2 = loadable(() => import("./WhatsNextAfterYTVideo2"), {
            fallback: lazyLoad  });
          const SetCourseExpiry = loadable(() => import("./SetCourseExpiry"), {
            fallback: lazyLoad  });
              
            

  const Navber = loadable(() => import("../../../Navbar/UserMenu"), {
    fallback: lazyLoad  });
  
    
  
 const CreateCourse = ()=>{
      const {url}=useRouteMatch();
      
  const history = useHistory();
      const dispatch = useDispatch();
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
    const [deviceWidth,setDeviceWidth] = useState(false);
           const bottomDivRef = useRef(null);
           
           const bottomDivBoxRef = useRef(null);
           const bodyWidthForMobile =useRef(null)
         
                  const [isVisible, setIsVisible] = useState(false);
                
                  const [divHeight, setDivHeight] = useState(0);
                           const [activeCardFolder, setActiveCardFolder] =useState(true);
                           const [activeCardOrganize, setActiveCardOrganize] =useState(false);
                           const [activeCardDrip, setActiveCardDrip] =useState(false);
                           const [activeCardAnalytics, setActiveCardAnalytics] =useState(false);
                           const [activeCardSubmissions, setActiveCardSubmissions] =useState(false);
                           const [activeCardQnA, setActiveCardQnA] =useState(false);
                           const [activeCardReviews, setActiveCardReviews] =useState(false);
                            const [colorThemeGrid, setColorThemeGrid] =useState(true);   
                            const [colorThemeList, setColorThemeList] =useState(false);   
                            const [selectCoursePopUp, setSelectCoursePopUp] =useState(false);   
                            
                             const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
const courseData = useSelector((state)=>state?.course?.course);

      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const user_email = useSelector((state)=>state?.user?.user?.user_email
);
const [activeStep, setActiveStep] = useState(0);
const [activeSubStepOne, setActiveSubStepOne] = useState(1);

const [activeSubStepTwo, setActiveSubStepTwo] = useState(0);
const [activeSubStepThree, setActiveSubStepThree] = useState(0);
const [activeSubStepFour, setActiveSubStepFour] = useState(0);
const [activeSubStepFive, setActiveSubStepFive] = useState(0);

const steps = [1, 2, 3, 4, 5];
const subSteps = [1, 2, 3, 4, 5];
const subStepOneTotal= 5;
const subStepTwoTotal= 3;
const subStepThreeTotal= 4;
const subStepFourTotal= 8;
const subStepFiveTotal= 1;
;
const handleNext = () => {
  if (activeStep < steps.length - 1) {
    setActiveStep((prev) => prev + 1);
  }
};

const handlePrev = () => {
  if (activeStep > 0) {
    setActiveStep((prev) => prev - 1);
  }
};

        useEffect(() => {
         
          // if(courseName){}else{setSelectCoursePopUp(true);}


           if (bodyWidthForMobile.current) {
             let offsetWidth = bodyWidthForMobile?.current?.offsetWidth;
               setDeviceWidth(offsetWidth)
           }
           setDivHeight(bottomDivBoxRef?.current?.offsetHeight);
           const observer = new IntersectionObserver(
             ([entry]) => {
               if (entry.isIntersecting) {
                 setIsVisible(true); // Set state when the div appears
               } else {
                 setIsVisible(false); // Reset state if it goes out of view
               }
             },
             {
               root: null, // Observe within the viewport
               threshold: 1.0, // Trigger only when fully visible (at the bottom of the viewport)
             }
           );
       
           if (bottomDivRef.current) {
             observer.observe(bottomDivRef.current);alert("jj")
           }
       
           return () => {
             if (bottomDivRef.current) {
               observer.unobserve(bottomDivRef.current);
             }
           };
         }, [deviceWidth])
     
    return <>
    
   
 <div className="gridForCreateContentOuterAll  " style={{ position:"relative",marginTop:"5px"}}   >
 
          
   
      <div className="coursePreviewAllOuterGrid" style={{ minHeight:"70vh", position:"relative"}}  >
     

     
     
      <div className=""
      // {`
      // ${!isVisible?"fixed-div-themes":"normal-div-last-themes"} 
      //  `}
        style={{ textAlign:"left",left:deviceWidth>551?mainMenuStatus?"270px":"170px":"0px",
          backgroundColor:"transparent",marginBottom:`${!isVisible?0:-divHeight}px ` ,marginTop:"25px"}} >
        <CourseMenuCardBlue activeCard={activeCardFolder}  icon={6} title ="Basics Info" onClickPopup={
          ()=>{setActiveCardFolder(true);setActiveCardOrganize(false);setActiveCardDrip(false);setActiveCardAnalytics(false);
            setActiveCardSubmissions(false);setActiveCardQnA(false);setActiveCardReviews(false);
              // history.push(`${url}`)
              
              }}  />
        <CourseMenuCardBlue activeCard={activeCardOrganize}  icon={2} title ="Labels" onClickPopup={
          ()=>{setActiveCardFolder(false);setActiveCardOrganize(true);setActiveCardDrip(false);setActiveCardAnalytics(false);
            setActiveCardSubmissions(false);setActiveCardQnA(false);setActiveCardReviews(false);
            // history.push(`${url}/subcourse-milestones`)
             }}  />
        <CourseMenuCardBlue activeCard={activeCardDrip} icon={7} title ="Additional Info" onClickPopup={()=>{
          setActiveCardFolder(false);setActiveCardOrganize(false);setActiveCardDrip(true);setActiveCardAnalytics(false);
          setActiveCardSubmissions(false);setActiveCardQnA(false);setActiveCardReviews(false);
          // history.push(`${url}/drip`)
          
          }}  />
        <CourseMenuCardBlue activeCard={activeCardAnalytics} icon={3} title ="Set Free Trial" onClickPopup={
          ()=>{setActiveCardFolder(false);setActiveCardOrganize(false);setActiveCardDrip(false);setActiveCardAnalytics(true);
            setActiveCardSubmissions(false);setActiveCardQnA(false);setActiveCardReviews(false);
          // history.push(`${url}/assignment-analytics`)
          
          }}  />
        <CourseMenuCardBlue activeCard={activeCardSubmissions} icon={4} title ="SEO " onClickPopup={
          ()=>{ setActiveCardFolder(false);setActiveCardOrganize(false);setActiveCardDrip(false);setActiveCardAnalytics(false);
            setActiveCardSubmissions(true);setActiveCardQnA(false);setActiveCardReviews(false);
            // history.push(`${url}/submissions`) 
             }}  />
        <CourseMenuCardBlue activeCard={activeCardQnA} icon={5} title ="Appearence" onClickPopup={()=>{
          setActiveCardFolder(false);setActiveCardOrganize(false);setActiveCardDrip(false);setActiveCardAnalytics(false);
          setActiveCardSubmissions(false); setActiveCardQnA(true);setActiveCardReviews(false);
          //  history.push(`${url}/comments-qna`) 
           
           }}  />
        <CourseMenuCardBlue activeCard={activeCardReviews} icon={1} title ="Settings " onClickPopup={
          ()=>{  setActiveCardFolder(false);setActiveCardOrganize(false);setActiveCardDrip(false);setActiveCardAnalytics(false);
            setActiveCardSubmissions(false); setActiveCardQnA(false);setActiveCardReviews(true);
            //  history.push(`${url}/reports-reviews`)
             
             }}  />
        </div>  
         </div>
         <div>
    <div className="CoursesFilterTw  " style={{zIndex:"99",marginTop:"30px"}} >
        <div className="CoursesFilterLeft" style={{zIndex:"99"}} >
{/*           
          <div  className="CoursesFilterTopTitle" >Course </div>
        <Link to={`/dashboard/create-course/course-name`}>   
         <div   className="CoursesFilterTopBtn"> Preview Course</div></Link> */}

        
<div   className=" progress-bar-container "> 
   <div className="progress-bark">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`circlek ${index <= activeStep ? "activek" : ""}` }
            style={{background: `${step ===1?
              `${activeSubStepOne?`conic-gradient(#565283 0% ${activeSubStepOne*100/subStepOneTotal}%, #ffffff 
                                                ${activeSubStepOne*100/subStepOneTotal}% 100%)`:""}`:
                                                step ===2?
                                                `${activeSubStepTwo?`conic-gradient(#565283 0% 
                                                ${activeSubStepTwo*100/subStepTwoTotal}%, #ffffff 
                                                ${activeSubStepTwo*100/subStepTwoTotal}% 100%)`:""}`: 
                                                step ===3?
                                                `${activeSubStepThree?`conic-gradient(#565283 0% 
                                                ${activeSubStepThree*100/subStepThreeTotal}%, #ffffff 
                                                ${activeSubStepThree*100/subStepThreeTotal}% 100%)`:""}`
                                                :step ===4?
                                                `${activeSubStepFour?`conic-gradient(#565283 0% 
                                                ${activeSubStepFour*100/subStepFourTotal}%, #ffffff 
                                                ${activeSubStepFour*100/subStepFourTotal}% 100%)`:""}`:
                                                step ===5?
                                                `${activeSubStepFive?`conic-gradient(#565283 0% 
                                                ${activeSubStepFive *100/subStepFiveTotal}%, #ffffff 
                                                ${activeSubStepFive*100/subStepFiveTotal}% 100%)`:""}`:""}
            `}} 
          ><div   className={`circlekInn `}>
             {step}
          </div>
           
          </div>
        ))}
      </div>  
    
      </div>
    
         </div> {courseData?<div><div className="CoursesFilterRight" style={{zIndex:"99"}} >
         <div className=""><div
          onClick={ ()=>{      
            history.push(`/preview-course/`)}}
          onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className=" CoursesPreviewTopBtn"> Preview Course</div>
 <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className="CoursesCreateTopBtn">Settings 
      <div   className=" CoursesCreateTopBtnInn " style={{width:"150px"}}>  
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
     onClick={ ()=>{      currentToken?history.push(`/dashboard/create-course/course-name/`):
      history.push(`/create-course/course-name/`)}}
      style={{width:"120px",border:"0px solid #fff"}}  
     className="CoursesCreateTopBtn">Basic Set Up </div>
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
     onClick={ ()=>{      currentToken?history.push(`/dashboard/create-course/course-whats-next-after-yt-videos/`):
      history.push(`/create-course/course-whats-next-after-yt-videos/`)}}
      style={{width:"120px",border:"0px solid #fff"}}  
     className="CoursesCreateTopBtn">Advanced Set up </div>
             {/* <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
     onClick={()=>{ 
      currentToken?history.push(`/dashboard/course-card-features/`):
      history.push(`/course-card-features/`)}}
     className="CoursesCreateTopBtn"style={{width:"180px"}}>Courses Card Features  </div> */}
          </div> 
     
     </div></div>
    <div className="">
 <div  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CoursesCreateTopBtn">  Manage
   <div   className=" CoursesCreateTopBtnInn " style={{width:"220px"}}>  
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className="CoursesCreateTopBtn" 
     style={{background:"rgba(149, 143, 218,0.8)",color:"#fff",width:"180px"}}> +Create A Batch </div>
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className="CoursesCreateTopBtn"style={{width:"180px"}}>Add To Membership Plan </div>
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"180px",border:"0px solid #fff"}}  
     className="CoursesCreateTopBtn">Add To Course Bundle </div>
       {/* <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{background:"rgba(149, 143, 218,0.8)",width:"180px",color:"#fff",border:"0px solid #fff"}}  
     className="CoursesCreateTopBtn">+Create Podcast </div> */}
      </div> 
   </div>
 <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     
     onClick={ ()=>{      currentToken?history.push(`/dashboard/create-content`):
      history.push(`/create-content`)}}
     className="CoursesCreateTopBtn">+ Add Contents </div> 
   </div>
   </div>    </div>:""}
   <div align="left" className="gridForTopSelectCOuseSetting" style={{background:"#ffffff",borderRadius:"15px",paddingLeft:"20px"}} >
        <h3 className="ButtonWithEllipsis"  >{courseData?.CourseName}</h3> 
       
    
       <Link  to={`/apps/${AppToken}/my-courses`} ><h3 style={{fontSize:"14px",color:"#565283",marginTop:"20px"}}>
         Change Course</h3></Link> 
       
          </div>
    </div>  
   


<Switch>
<Route path={`${url}/course-name/`}>
    
    <CourseTitle baseUrl={url}/>
    </Route>

    <Route path={`${url}/course-whats-included/`}>
    
    <WhatsIncluded baseUrl={url}/>
    </Route>
    <Route path={`${url}/course-add-thumbnail/`}>
    
    <AddThumbnail baseUrl={url}/>
    </Route>
    <Route path={`${url}/course-add-demo-videos/`}>
    
    <AddDemoVideos baseUrl={url}/>
    </Route>

    
    <Route path={`${url}/course-set-course-price/`}>
    
    <SetCoursePriceType baseUrl={url}/>
    </Route>
    <Route path={`${url}/course-whats-next-after-yt-videos/`}>
    
    <WhatsNextAfterYTVideo baseUrl={url}/>
    </Route>
    <Route path={`${url}/course-whats-next-after-yt-videos-next/`}>
    
    <WhatsNextAfterYTVideo2 baseUrl={url}/>
    </Route>
    <Route path={`${url}/course-set-expiry/`}>
    
    <SetCourseExpiry baseUrl={url}/>
    </Route>
   

    
 
</Switch> 
        
</div>
</div>
           
    </>

}
export default CreateCourse;
